<template>
  <b-modal title="Session Timeout" v-model="showPopup" no-close-on-backdrop hide-header-close>
    <p>Your session is about to expire in</p> 
    <p> {{ formatTime(countdownTime) }}</p>
    <p> To stay logged in, please select "Continue Session."</p>
    <div slot="modal-footer" class="modal-footer-buttons" style="justify-content: space-between; display: flex;">
      <div class="modal-footer-left" style="padding-left: 200px;">
        <button class="modal-button primary-button" @click="handleContinueSession">Continue Session</button>
      </div>
      <div class="modal-footer-right" style="padding-left: 20px;">
        <button class="modal-button danger-button" @click="logoutSession">Log Out</button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'SessionLogout',
  data () {
    return {
      sessionTimeout: 15 * 60 * 1000,
      popupDuration: 5 * 60 * 1000,
      sessionTimer: null,
      popupTimer: null,
      countdownInterval: null,
      showPopup: false,
      countdownTime: 0
    }
  },
  mounted () {
    this.startSessionTimeout()
    this.initializeActivityListeners()
  },
  beforeDestroy () {
    this.clearTimers()
    this.removeActivityListeners()
  },
  methods: {
    startSessionTimeout () {
      this.sessionTimer = setTimeout(() => {
        this.showPopup = true
        this.startPopupTimer()
      }, this.sessionTimeout)
    },
    resetInactiveTimer () {
      clearTimeout(this.sessionTimer)
      this.startSessionTimeout()
    },
    updateLastActiveLoacalStorage () {
      window.localStorage.setItem('last-active-session-event', Date.now())
    },
    initializeActivityListeners () {
      window.addEventListener('click', (event) => {
        this.updateLastActiveLoacalStorage()
        this.resetInactiveTimer()
      })
      window.addEventListener('keydown', this.resetInactiveTimer)
      window.addEventListener('storage', (event) => {
        if (event.key === 'last-active-session-event') {
          this.extendSession()
        }
      })
    },
    startPopupTimer () {
      this.popupTimer = setTimeout(() => {
        this.logoutSession()
      }, this.popupDuration)
      this.startCountdown()
    },
    startCountdown () {
      this.countdownTime = Math.floor(this.popupDuration / 1000)
      clearInterval(this.countdownInterval)
      this.countdownInterval = setInterval(() => {
        this.countdownTime--
        if (this.countdownTime <= 0) {
          clearInterval(this.countdownInterval)
        }
      }, 1000)
    },
    handleContinueSession () {
      this.extendSession()
      this.updateLastActiveLoacalStorage()
    },
    extendSession () {
      clearTimeout(this.popupTimer)
      clearInterval(this.countdownInterval)
      this.showPopup = false
      this.resetInactiveTimer()
    },
    logoutSession () {
      this.clearTimers()
      this.removeActivityListeners()
      this.$store.dispatch('logOut')
      this.$router.push('/log_in')
    },
    clearTimers () {
      clearTimeout(this.sessionTimer)
      clearTimeout(this.popupTimer)
      clearInterval(this.countdownInterval)
    },
    removeActivityListeners () {
      window.removeEventListener('click', this.resetInactiveTimer)
      window.removeEventListener('keydown', this.resetInactiveTimer)
    },
    formatTime (seconds) {
      const minutes = Math.floor(seconds / 60)
      const remainingSeconds = seconds % 60
      const formattedMinutes = minutes.toString().padStart(2, '0')
      const formattedSeconds = remainingSeconds.toString().padStart(2, '0')
      return `${formattedMinutes}:${formattedSeconds}`
    }
  }
}
</script>

<style scoped>
.modal-footer-buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-button {
    padding: 10px 20px;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
    border-radius: 5px;
    background-color: #fff;
}
.modal-button:hover {
  background-color: #f0f0f0;
  color: #333;
}

.primary-button {
    background-color: black;
    color: #fff;
}

.primary-button:hover {
    background-color: #cfc2c4;
}

.danger-button {
    background-color: #dc3545;
    color: #fff;
}

.danger-button:hover {
    background-color: #cfc2c4;
}

</style>



// WEBPACK FOOTER //
// src/components/Sessionlogout.vue